<template>
  <v-card class="mx-auto px-2 py-4" outlined width="100%" height="100%">
    <v-list-item three-line>
      <v-list-item-content>
        <v-list-item-title class="headline mb-1 card_header">
          {{ card.title }}
        </v-list-item-title>
        <v-list-item-subtitle
          class="mt-3 mb-1 card_body"
          v-html="card.description"
        />
      </v-list-item-content>

      <v-list-item-avatar
        v-if="card.icon && this.$vuetify.breakpoint.smOnly === false"
        tile
      >
        <v-img
          alt="Local image"
          class="shrink"
          contain
          :src="require('../../assets/' + card.icon)"
          width="35px"
          height="41px"
        />
      </v-list-item-avatar>
    </v-list-item>

    <v-card-actions>
      <v-btn
        v-if="card.action_button === 'Saber mais'"
        color="#3C3ED2"
        outlined
        class="card_action pa-3"
        @click="scrollToElement('specialities')"
      >
        {{ card.action_button }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "HeaderCard",

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  data: () => ({}),

  methods: {
    scrollToElement(element, offset = 0) {
      this.$scrollTo(`#${element}`, 500, { offset: -92 + offset });
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/scss/variables.scss";

.card_header {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: nexa_bold !important;
  font-size: 23px;
  letter-spacing: 0;
  line-height: 28px;
  text-overflow: unset;
  white-space: unset;
}

.card_body {
  color: map-get($theme-colors, "dark-blue") !important;
  font-family: "Roboto" !important;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 20px;
  text-overflow: unset;
  white-space: unset;
  -webkit-line-clamp: unset;
}

.card_action {
  color: map-get($theme-colors, "blue") !important;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 1px;
  line-height: 16px;
}

@media only screen and (min-width: 600px) and (max-width: 972px) {
  .v-list-item .v-list-item__title {
    min-height: 56px !important;
  }

  .v-list-item .v-list-item__subtitle {
    min-height: 140px !important;
  }
}

@media only screen and (min-width: 972px) {
  .v-list-item .v-list-item__subtitle {
    min-height: 80px !important;
  }
}

.v-list-item .v-list-item__title {
  min-height: 30px;
}

.v-list-item .v-list-item__subtitle {
  min-height: 40px;
}
</style>
